module.exports = __webpack_public_path__ + "img/green_109.0a25f01d.png";